





























































import Vue, {VueConstructor} from 'vue'
import {DateTime} from 'luxon'
import {
  VOTE_TYPE_YESNO,
  VOTE_TYPE_STARS5,
  VOTE_TYPE_LIKE
} from '@/constants'

export default (Vue as VueConstructor<Vue & {
}>).extend({
  name: 'FourthStep',
  props: {
    scope: {} as () => {mailingId: string},
  },
  data () {
    return {
      likes: false,
      rating: false,
      voteType: null,
      VOTE_TYPE_YESNO,
      VOTE_TYPE_STARS5,
      VOTE_TYPE_LIKE
    }
  },
  computed: {
  },
  methods: {
    prev () {
      this.$emit('prev')
    },
    submit () {
      this.$emit('submit')
    },
    onSettingClick (type: string | null) {
      // @ts-ignore
      this.voteType = type;
    },
    setData () {
      this.$emit('input', {vote_type: this.voteType})
    }
  },
  mounted () {
    this.setData()
  },
  watch: {
    voteType () {
      this.setData()
    }
  }
})
